import { render, staticRenderFns } from "./SettingMenu.vue?vue&type=template&id=a898a91c&scoped=true&"
import script from "./SettingMenu.vue?vue&type=script&lang=js&"
export * from "./SettingMenu.vue?vue&type=script&lang=js&"
import style0 from "./SettingMenu.vue?vue&type=style&index=0&id=a898a91c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a898a91c",
  null
  
)

export default component.exports